module.exports = __webpack_public_path__ + "media/images/sp/stores/omiya/omiya_sns_04-aa718e9111ba3b53cd5c625c9aea4095.jpg";